import { render } from "./VrBaseModal.vue?vue&type=template&id=3fc26703&scoped=true"
import script from "./VrBaseModal.vue?vue&type=script&lang=js"
export * from "./VrBaseModal.vue?vue&type=script&lang=js"

import "./VrBaseModal.vue?vue&type=style&index=0&id=3fc26703&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc26703"]])

export default __exports__